import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { NgbDropdown, NgbDropdownModule, Placement } from '@ng-bootstrap/ng-bootstrap';

import { RxDrownAutoClose } from './rich-dropdown.models';
import { CommonModule } from '@angular/common';

/*
Basic usage:
<rx-rich-dropdown>
  <div host buttonClass="secondary"> The element used as reference for positioning the dropdown</div>
  <ng-container menuLabel>The title shown in a dropdown</ng-container>
  <button class="dropdown-item">item 1</button>
  <button class="dropdown-item">item 2</button>
</rx-rich-dropdown>
*/

@Component({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-rich-dropdown',
  templateUrl: './rich-dropdown.component.html',
  styleUrls: ['./rich-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgbDropdownModule],
})
export class RichDropdownComponent {
  @ViewChild('dropdown', { static: true }) dropdown: NgbDropdown;
  @Input() showHeader = true;
  @Input() autoClose: RxDrownAutoClose = true;
  @Input() placement: Placement = 'bottom-left';
  @Input() compact = false;
  @Input() extraCompact = false;
  @Input() selectStyle = false;
  @Input() highlight = false;
  @Output() dropdownOpenChange: EventEmitter<boolean> = new EventEmitter();
}
